import Link from "next/link";
import React, { useContext, useState, useTransition } from "react";
import { useEffect } from "react";
import { Button } from "react-bootstrap";
import helper from "../../lib/helper";
import roleModel from "../../models/roles.model";
import useSWR from "swr";
import Pagination from "../../components/Pagination";
import Heading from "../../components/Heading";
import Table from "../../components/Table";
import { useRouter } from "next/router";
import config from "../../lib/config";
const Page = function () {
    const [showLoader, setShowLoader] = useState(false);
    const router = useRouter();
    const queryParams = router.query;
    const { data: rolesData, mutate: realoadPageData, isLoading } = useSWR(
        queryParams || null,
        () => roleModel.list(),
        config.swrConfig
    );
    console.log('rolesData', rolesData)
    const columns = [
        {
            Header: "Name",
            accessor: "name",
            className: "col"
        },
        {
            Header: "Date",
            id: "created_at",
            Cell: ({ row }) => (
                <>
                    <div>
                    {helper.date.format(row.original.created_at)}
                    </div>
                </>
            )
            }, 
        
        
        
        {
            className: "col-auto text-end",
            Header: "Actions",
            id: "action",
            Cell: ({ row }) => (
                <>
                    <div className="btn-group btn-group-sm">
                        <Link
                            className="btn btn-primary"
                            href={`/roles/${row.original.id}`}
                        >
                            <i className="bi bi-eye"></i>
                        </Link>
                        <Link
                            className="btn btn-warning"
                            href={`/roles/${row.original.id}/edit`}
                        >
                            <i className="bi bi-pencil-square"></i>
                        </Link>
                        <button
                            className="btn btn-danger"
                            onClick={() => confirmDelete(row.original.id, row.original.name)}
                        >
                            <i className="bi bi-trash"></i>
                        </button>
                    </div>
                </>
            ),
        },
    ];
    const confirmDelete = async (id, title) => {
        await helper.sweetalert
            .confirm(`confirm to delete ${title}`, "warning")
            .then(async (result) => {
                if(result.isConfirmed){
                setShowLoader(true);
                await roleModel.destroy(id).then((res) => {
                    realoadPageData();
                    helper.sweetalert.toast(`${title} deleted Successfully`);
                });
                setShowLoader(false);
    }});
    };
    return (
        <>
            <Heading title="Role and Permission" showLoader={isLoading || showLoader}>
                <Button className="btn btn-primary btn-sm" href="/roles/create">
                    Create
                </Button>
            </Heading>
            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">Roles Lists</div>
                    <div className="table-responsive">
                        <Table columns={columns} data={rolesData?.data || []} key='rolelist' />
                        {console.log('rolesDataaa', rolesData)}
                    </div>
                    <div className="card-footer">
                        <Pagination meta={rolesData?.meta} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
